// import { catchError } from 'rxjs/operators';
import { ecorEnv } from '@/../environments/environment';
import { HttpClient, HttpErrorResponse, HttpEvent, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

@Injectable()
export class SubmitCaseService {
    constructor(private httpClient: HttpClient) { }

    getFaqs(id: string) {
        const params = new HttpParams()
            .set('taxonomyLinkId', id);
        const faqUrl = ecorEnv.apiEndpoint + '/secure/pega/cases/faqs';
        return this.httpClient.get<any>(faqUrl, { params: params })
            .pipe(
                // catchError(this.handleError)
            );
    }

    getCasesTopics(topicType: string, caseType: string): Observable<any> {
        const params = new HttpParams()
            .set('topicType', topicType)
            .set('caseType', caseType);

        const casesTopicsUrl = ecorEnv.apiEndpoint + '/pega/cases/topics';
        return this.httpClient.get<any>(casesTopicsUrl, { params: params })
            .pipe(
                // catchError(this.handleError)
            );
    }

    getCasesByEmailAndType(email: string, caseType: string): Observable<any> {
        const params = new HttpParams()
            .set('caseType', caseType);
        const caseTypesUrl = ecorEnv.apiEndpoint + '/secure/pega/cases/' + email;
        return this.httpClient.get<any>(caseTypesUrl, { params: params })
            .pipe(
                // catchError(this.handleError)
            );
    }

    uploadFiles(formParam: any, formData: FormData): Observable<HttpEvent<any>> {
        const params = new URLSearchParams();
        for (const key in formParam) {
            params.set(key, formParam[key]);
        }

        const url = ecorEnv.apiEndpoint + '/pega/cases?' + params.toString();

        // console.log('submit-case', 'post url', url);

        return this.httpClient.post<HttpEvent<any>>(url, formData, {
            reportProgress: true,
            observe: 'events',
            withCredentials: false,
            // headers: { 'Content-Type': 'multipart/form-data' }
        })
            .pipe(
                // catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('submit-case', 'error', error);
        if (error.error instanceof ErrorEvent) {
            console.error('submit-case', 'client side error:', error.error.message);
        } else {
            return throwError('Error-111111');
        }
        return throwError('Error-222222');
    }
}
